import { useState, useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from '../config';

let cachedAccounts = null;
let cachedOccasions = null;

export function usePaymentDropdowns() {
    const [bankAccounts, setBankAccounts] = useState(cachedAccounts || []);
    const [specialOccasions, setSpecialOccasions] = useState(cachedOccasions || []);

    useEffect(() => {
        const headers = { Authorization: `Bearer ${localStorage.getItem('accessToken')}` };
        const fetches = [];

        if (!cachedAccounts) {
            fetches.push(
                axios.get(`${baseUrl}/bank-account/active`, { headers })
                    .then(res => {
                        if (res.data.status && res.data.result?.length > 0) {
                            cachedAccounts = res.data.result;
                            setBankAccounts(res.data.result);
                        }
                    })
                    .catch(() => {})
            );
        }

        if (!cachedOccasions) {
            fetches.push(
                axios.get(`${baseUrl}/special-occasion/active`, { headers })
                    .then(res => {
                        if (res.data.status && res.data.result?.length > 0) {
                            cachedOccasions = res.data.result;
                            setSpecialOccasions(res.data.result);
                        }
                    })
                    .catch(() => {})
            );
        }
    }, []);

    return { bankAccounts, specialOccasions };
}

// Call this after adding/editing accounts or occasions via admin pages to force re-fetch
export function clearPaymentDropdownCache() {
    cachedAccounts = null;
    cachedOccasions = null;
}
